export function ADD_CUSTOMER_REVIEW(state, customerReview) {
    state.customerReviews = Object.assign({}, state.customerReviews, {
      [customerReview.productID]: customerReview,
    })
}
